import React, { useContext, useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import { Design, SamplePageNameEn } from '../../lib/FL';
import DeviceSwitch from '../atom/DeviceSwitch';
import ColorButtons from '../atom/ColorButtons';
import PreviewFrame from '../atom/PreviewFrame';

import styles from './PreviewModal.module.scss';

type Props = {
  design: Design;
  business: SamplePageNameEn;
};

const DesignPreviewModal: React.FC<Props> = ({ design, business }) => {
  const setModal = useContext(ModalDispatchContext);
  const closeModal = () => setModal(null);

  const [activeColorId, setActiveColorId] = useState<string>(design.demo_color_id);
  const [device, setDevice] = useState<string>('pc');

  useEffect(() => {
    const previewIframe = document.getElementById('preview') as HTMLIFrameElement;
    previewIframe?.contentWindow?.postMessage({ color: activeColorId }, '*');
  }, [activeColorId]);

  return (
    <div className={styles.wrapper} onClick={(e) => e.stopPropagation()} role='button'>
      <header className={styles.header}>
        <div className={styles.header__left}>
          <h2 className={styles.title}>
            <span className={styles.title__main}>{design.ja_name}</span>
            <span className={styles.title__sub}>{design.en_name}</span>
            <a
              href={`${window.location.origin}/type${design.type}/${business}.php?color=${activeColorId}`}
              target='_blank'
              rel='noreferrer'
            >
              <button type='button'>
                <FontAwesomeIcon icon={faExternalLink} className={styles.title__link} />
              </button>
            </a>
          </h2>
        </div>
        <div className={styles.header__center}>
          <DeviceSwitch activeDevice={device} setActiveDevice={(d: string) => setDevice(d)} />
        </div>
        <div className={styles.header__right}>
          <ColorButtons
            colors={design.colors}
            activeColorId={activeColorId}
            setActiveColorId={(id: string) => setActiveColorId(id)}
          />
          <button className={styles.close} type='button' onClick={closeModal}>
            <FontAwesomeIcon icon={faTimes} className={styles.close__icon} />
          </button>
        </div>
      </header>
      <div className={styles.preview}>
        <PreviewFrame device={device}>
          <iframe
            src={`/type${design.type}/${business}.php?hideChange=on`}
            id='preview'
            className={styles.iframe}
            title='プレビュー'
          />
        </PreviewFrame>
      </div>
    </div>
  );
};

export default DesignPreviewModal;
